(() => {
  if (customElements.get('flasyon-benefits')) return;
  const money = cents => new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(cents / 100);
  let locationRequest;
  document.addEventListener('variant:change', event => {
    document.querySelectorAll('flasyon-benefits').forEach(block => {
      if(block.dataset.formId === event.detail?.formId) block.setVariant(event.detail.variant);
    });
  });
  class FlasyonBenefits extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.renderPrice();
      this.querySelector('[data-cep-button]')?.addEventListener('click', () => this.lookupCep());
      this.querySelector('[data-cep]')?.addEventListener('keydown', e => {if(e.key === 'Enter'){e.preventDefault();this.lookupCep();}});
      this.addEventListener('flasyon:variant', e => this.setVariant(e.detail));
      this.detectLocation();
    }
    static get observedAttributes(){ return ['data-price']; }
    attributeChangedCallback(){ if(this.ready) this.renderPrice(); }
    setVariant(variant){
      if(!this.querySelector('[data-pix]')) return;
      this.hidden = !(variant && Number.isSafeInteger(variant.price) && variant.price >= 0);
      if(!this.hidden) this.dataset.price = variant.price;
    }
    renderPrice(){
      const price = Number(this.dataset.price);
      if(!Number.isSafeInteger(price) || price < 0) return;
      const set = (name,text) => { const el=this.querySelector(`[data-${name}]`); if(el) el.textContent=text; };
      set('total', money(price));
      set('pix', money(Math.round(price * 90 / 100)));
      set('installment', money(Math.ceil(price / 12)));
    }
    async json(url){
      const controller=new AbortController();
      const timeout=setTimeout(()=>controller.abort(),6000);
      try{const r=await fetch(url,{signal:controller.signal,credentials:'omit'});if(!r.ok)throw Error('network');return await r.json();}
      finally{clearTimeout(timeout);}
    }
    location(city,region,approximate=false){
      const el=this.querySelector('[data-location]');
      if(el) el.textContent=`para ${city}, ${region}`;
      const note=this.querySelector('[data-location-note]');
      if(note) note.textContent=approximate?'Localização aproximada. Confirme ou altere pelo CEP.':'Localização consultada pelo CEP.';
    }
    async detectLocation(){
      if(this.dataset.autoLocation !== 'true') return;
      try{
        locationRequest ||= this.json('https://get.geojs.io/v1/ip/geo.json');
        const data=await locationRequest;
        if(!this.manualLocation && data.country_code==='BR' && data.city && data.region && typeof data.city==='string' && typeof data.region==='string') this.location(data.city,data.region,true);
      }catch{/* Nationwide free shipping and CEP remain available. */}
    }
    async lookupCep(){
      const input=this.querySelector('[data-cep]');
      const message=this.querySelector('[data-cep-message]');
      const button=this.querySelector('[data-cep-button]');
      const cep=input.value.replace(/\D/g,'');
      if(!/^\d{8}$/.test(cep)){message.textContent='Digite um CEP com 8 números.';input.focus();return;}
      this.manualLocation=true;
      button.disabled=true;message.textContent='Consultando CEP…';
      try{
        const data=await this.json(`https://viacep.com.br/ws/${cep}/json/`);
        if(data.erro || !data.localidade || !data.uf) throw Error('cep');
        this.location(data.localidade,data.uf);
        message.textContent='Frete grátis confirmado para esta região.';
      }catch{message.textContent='Não foi possível consultar. Confira o CEP e tente novamente. O frete continua grátis para todo o Brasil.';}
      finally{button.disabled=false;}
    }
  }
  customElements.define('flasyon-benefits', FlasyonBenefits);
})();
